import React from 'react';

export interface TableContextProps {
  tableId?: number;
  name?: string;
  data: Object[];
  emptyValue?: string;
  debug?: boolean;
  rowPadding?: string | number;
  headPadding?: string | number;
  displayMode?: 'flex' | 'table';
  noCellWrap?: boolean;
}

const TableContext = React.createContext<TableContextProps>({ data: [] });

export default TableContext;
